import { render } from "./ExternalLayout.vue?vue&type=template&id=6151871b&ts=true"
import script from "./ExternalLayout.vue?vue&type=script&lang=ts"
export * from "./ExternalLayout.vue?vue&type=script&lang=ts"

import "./ExternalLayout.vue?vue&type=style&index=0&id=6151871b&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__